// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Proveedores_container__33NZ0 {
  animation: Proveedores_init__n8qjx 1s;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  font-size: 1rem;
  margin-bottom: 50px;
}

/*--Header--*/
.Proveedores_container__33NZ0 .Proveedores_header__NA984 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Proveedores_container__33NZ0 .Proveedores_header__NA984 .Proveedores_filters__BPsqQ {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.Proveedores_container__33NZ0 .Proveedores_header__NA984 .Proveedores_filters__BPsqQ .Proveedores_filterButton__aO6mV {
  text-transform: capitalize;
  height: 3rem;
  width: 10rem;
  margin-bottom: 10px;
  border-radius: 5px;
  margin-left: 5px;
}

.Proveedores_container__33NZ0 .Proveedores_header__NA984 .Proveedores_filters__BPsqQ .Proveedores_filterButton__aO6mV p {
  font-size: 0.9rem;
  margin-left: 5px;
  font-weight: 400;
}

.Proveedores_container__33NZ0 .Proveedores_noResults__pXLdC {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 1.5rem;
  font-weight: 300;
  height: 300px;
}

.Proveedores_container__33NZ0 .Proveedores_header__NA984 .Proveedores_titleContainer__rNyCI .Proveedores_add_btn__fkmSP {
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2.5rem;
  width: 6.5rem;
  text-transform: capitalize;
  border-radius: 5px;
  font-size: 1rem;
  font-weight: 300;
  font-family: Roboto, sans-serif;
  margin-left: 10px;
}

.Proveedores_container__33NZ0 .Proveedores_header__NA984 .Proveedores_titleContainer__rNyCI {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.Proveedores_container__33NZ0 .Proveedores_header__NA984 .Proveedores_titleContainer__rNyCI h4 {
  font-size: 1.6rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin-left: 10px;
}

/*---Información---*/
.Proveedores_container__33NZ0 .Proveedores_dataContainer__pSBOk {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 500px;
}

.Proveedores_container__33NZ0 .Proveedores_dataContainer__pSBOk .Proveedores_tableContainer__JMtxX {
  border-radius: 10px;
  max-height: 80vh;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.Proveedores_container__33NZ0 .Proveedores_dataContainer__pSBOk .Proveedores_tableContainer__JMtxX .Proveedores_iconbtn__H146G {
  transition: 0.3s;
  font-size: 1.6rem;
}

.Proveedores_container__33NZ0 .Proveedores_dataContainer__pSBOk .Proveedores_tableContainer__JMtxX .Proveedores_iconbtn__H146G:hover {
  transition: 0.3s;
  cursor: pointer;
  filter: brightness(0.7);
  scale: 1.1;
}

@keyframes Proveedores_init__n8qjx {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

/*XS*/
@media screen and (max-width: 500px) {
  .Proveedores_container__33NZ0 .Proveedores_header__NA984 .Proveedores_titleContainer__rNyCI .Proveedores_add_btn__fkmSP {
    width: 80px;
    height: 40px;
  }
  .Proveedores_container__33NZ0 .Proveedores_header__NA984 .Proveedores_titleContainer__rNyCI h4 {
    font-size: 1.5rem;
  }
}

/*MD*/
@media screen and (max-width: 900px) {
  .Proveedores_container__33NZ0 .Proveedores_header__NA984 .Proveedores_filters__BPsqQ .Proveedores_filterButton__aO6mV {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Proveedores/Proveedores.module.css"],"names":[],"mappings":"AAAA;EACE,qCAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,KAAK;AACL;EACE;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA,KAAK;AACL;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".container {\n  animation: init 1s;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  font-size: 1rem;\n  margin-bottom: 50px;\n}\n\n/*--Header--*/\n.container .header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.container .header .filters {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.container .header .filters .filterButton {\n  text-transform: capitalize;\n  height: 3rem;\n  width: 10rem;\n  margin-bottom: 10px;\n  border-radius: 5px;\n  margin-left: 5px;\n}\n\n.container .header .filters .filterButton p {\n  font-size: 0.9rem;\n  margin-left: 5px;\n  font-weight: 400;\n}\n\n.container .noResults {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-size: 1.5rem;\n  font-weight: 300;\n  height: 300px;\n}\n\n.container .header .titleContainer .add_btn {\n  transition: 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 2.5rem;\n  width: 6.5rem;\n  text-transform: capitalize;\n  border-radius: 5px;\n  font-size: 1rem;\n  font-weight: 300;\n  font-family: Roboto, sans-serif;\n  margin-left: 10px;\n}\n\n.container .header .titleContainer {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .header .titleContainer h4 {\n  font-size: 1.6rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin-left: 10px;\n}\n\n/*---Información---*/\n.container .dataContainer {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  min-height: 500px;\n}\n\n.container .dataContainer .tableContainer {\n  border-radius: 10px;\n  max-height: 80vh;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.container .dataContainer .tableContainer .iconbtn {\n  transition: 0.3s;\n  font-size: 1.6rem;\n}\n\n.container .dataContainer .tableContainer .iconbtn:hover {\n  transition: 0.3s;\n  cursor: pointer;\n  filter: brightness(0.7);\n  scale: 1.1;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n/*XS*/\n@media screen and (max-width: 500px) {\n  .container .header .titleContainer .add_btn {\n    width: 80px;\n    height: 40px;\n  }\n  .container .header .titleContainer h4 {\n    font-size: 1.5rem;\n  }\n}\n\n/*MD*/\n@media screen and (max-width: 900px) {\n  .container .header .filters .filterButton {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Proveedores_container__33NZ0`,
	"init": `Proveedores_init__n8qjx`,
	"header": `Proveedores_header__NA984`,
	"filters": `Proveedores_filters__BPsqQ`,
	"filterButton": `Proveedores_filterButton__aO6mV`,
	"noResults": `Proveedores_noResults__pXLdC`,
	"titleContainer": `Proveedores_titleContainer__rNyCI`,
	"add_btn": `Proveedores_add_btn__fkmSP`,
	"dataContainer": `Proveedores_dataContainer__pSBOk`,
	"tableContainer": `Proveedores_tableContainer__JMtxX`,
	"iconbtn": `Proveedores_iconbtn__H146G`
};
export default ___CSS_LOADER_EXPORT___;
